// пока оставляем так, позже перенастроить стили скролла
// Создаем стилизованный контейнер со скроллбаром
import styled from "styled-components";

export const ScrollContainer = styled.div`
  overflow-y: auto;
  flex: 1;
  //margin-bottom: 58px;

  /* Плавная анимация скролла */
  scroll-behavior: smooth;

  /* Скрыть скроллбар на мобильных устройствах */
  @media (max-width: 768px) {
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  /* Стили для десктопа */
  @media (min-width: 769px) {
    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.2);
      border-radius: 4px;

      &:hover {
        background: rgba(255, 255, 255, 0.4);
      }

      &:active {
        background: rgba(255, 255, 255, 0.6);
      }
    }
  }

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
`;
